export const environment = {
  production: false,
  apiUrl: 'http://kinsphere360.vizipp.com',
  apiBase: '/api/v1',
};
